export const socialLinks = {
    linkedin: "https://www.linkedin.com/in/angel-gama/",
    github: "https://github.com/AngelGama",
    gdev: "https://g.dev/Angel_Gama",
}